import React from 'react';
import PropTypes from 'prop-types';
import Footer from 'js/components/CCUFooter';
import Header from '../../components/Header';
import style from './style.css';

export default class DemoLayout extends React.Component {
    static propTypes = {
        children: PropTypes.node,
        className: PropTypes.string,
        showSecondaryNav: PropTypes.bool,
    };

    static defaultProps = {
        className: 'container-fluid',
        showSecondaryNav: false,
    };

    render() {
        return (
            <div className={style.wrapper}>
                <Header className={this.props.className} />
                <div className={style.body}>
                    <div className={this.props.className}>{this.props.children}</div>
                </div>
                <div className={style.footer}>
                    <Footer className={this.props.className} />
                </div>
            </div>
        );
    }
}
